import { render, staticRenderFns } from "./OrganizationPermissionLine.vue?vue&type=template&id=1d00465b&"
import script from "./OrganizationPermissionLine.vue?vue&type=script&lang=js&"
export * from "./OrganizationPermissionLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports